module.exports = __webpack_public_path__ + "src/img/link.91de8a23.svg";